<div fxLayout="column">
  <neq-select-autocomplete [dataSource]="fetchBaseClasses" defaultLabel="{{'label.common.search' | translate}}"
                           bindLabel="label" (change)="onSelectClass($event)" [(ngModel)]="selectedClass"
                           class="neq-result-select">
    <ng-template let-item="item" let-index="index">
      <i class="fas fa-{{item.meta ? 'clone' : 'square'}} class-icon"></i>
      <span>{{item.label}}</span>
    </ng-template>
  </neq-select-autocomplete>
  <ng-container *ngIf="tableData && tableData.results">
    <p-table [columns]="cols" [value]="tableData.results"
             styleClass="neq-primeng-table neq-primeng-table-little raw-table" fxFlex>
      <ng-template pTemplate="header" let-columns>
        <tr>
          <ng-container *ngFor="let col of columns">
            <th
              *ngIf="col.field !== 'nutrientUnit' || showUnit"
              class="primeng-table-{{col.position}}-cell">
              {{col.header | translate}}
            </th>
          </ng-container>
          <ng-container *ngFor="let column of resultPrefs; index as i">
            <th [innerHTML]="getColumnValue(column)" [title]="getColumnTitle(column)" class="primeng-table-center-cell"></th>
          </ng-container>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowData let-columns="columns" let-i="rowIndex">
        <tr>
          <ng-container *ngFor="let col of columns">
            <td class="primeng-table-center-cell" *ngIf="col.field !== 'nutrientUnit' || showUnit">
              <ng-container *ngIf="col.field === 'nutrientLabel'">
                <div fxLayout="row wrap" [matTooltip]="rowData.nutrientDescription  == '' ? rowData.nutrientLabel : rowData.nutrientDescription"
                     matTooltipPosition="below">
                  <ng-container *ngIf="rowData.technicalDocAvailable">
                    <a (click)="getNutrientTechnicalDocUrl(rowData)" target="_blank" class="no-link">{{rowData.nutrientLabel}}</a>
                  </ng-container>
                  <ng-container *ngIf="!rowData.technicalDocAvailable">
                    {{rowData.nutrientLabel}}
                  </ng-container>
                </div>
              </ng-container>
  
              <ng-container *ngIf="col.field === 'nutrientUnit'">
                {{ rowData[col.field] }}
              </ng-container>
            </td>
          </ng-container> 
          
          <ng-container *ngFor="let column of resultPrefs; index as i">
            <td class="primeng-table-right-cell">
              <span
                [class.ceil-or-floor-reached]="isCeilOrFloorReachedAndNotStandard(rowData, i)"
                matTooltip="{{ getValueTooltip(rowData, i)}}"
                [class.error]="isOutOfTolerance(rowData, i)"
              >{{getNumberFromRow(rowData, i)}}</span>
            </td>
          </ng-container>
        </tr>
      </ng-template>
    </p-table>
  </ng-container>
</div>
